import { render, staticRenderFns } from "./ClientPhone.vue?vue&type=template&id=b72d5dba&scoped=true"
import script from "./ClientPhone.vue?vue&type=script&lang=js"
export * from "./ClientPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72d5dba",
  null
  
)

export default component.exports